import { FilterModalSelect } from './FilterModal';
import { MeansOfTransportType } from '../common.types';
import { Dispatch, SetStateAction } from 'react';
import { SelectOption } from '@rio-cloud/rio-uikit/Select';
import { FormattedMessage } from 'react-intl';

const MEANS_OF_TRANSPORT_TYPES: { id: string; labelId: string }[] = [
    {
        id: MeansOfTransportType.TRUCK,
        labelId: 'outboundOrderBook.common.meansOfTransportType.truck',
    },
    {
        id: MeansOfTransportType.OWN_WHEELS,
        labelId: 'outboundOrderBook.common.meansOfTransportType.ownWheels',
    },
    {
        id: MeansOfTransportType.TRAIN,
        labelId: 'outboundOrderBook.common.meansOfTransportType.train',
    },
    {
        id: MeansOfTransportType.RORO_VESSEL,
        labelId: 'outboundOrderBook.common.meansOfTransportType.roroVessel',
    },
    {
        id: MeansOfTransportType.CONTAINER_VESSEL,
        labelId: 'outboundOrderBook.common.meansOfTransportType.containerVessel',
    },
];
export const getMeansOfTransportTypeOptions = (): SelectOption[] =>
    MEANS_OF_TRANSPORT_TYPES.map(({ id, labelId }) => ({
        id,
        label: <FormattedMessage id={labelId} />,
    }));

export interface MeansOfTransportTypeFilterProps<T, K extends keyof T> {
    label?: string;
    filterName: K;
    localFilters: T;
    setLocalFilters: Dispatch<SetStateAction<T>>;
}

export const MeansOfTransportTypeFilter = <T, K extends keyof T>({
    label = 'outboundOrderBook.compoundManagement.filter.meansOfTransportType',
    filterName,
    localFilters,
    setLocalFilters,
}: MeansOfTransportTypeFilterProps<T, K>) => {
    return (
        <FilterModalSelect
            labelMessageId={label}
            inputAddon="rioglyph rioglyph-road"
            placeholderMessageId="outboundOrderBook.compoundManagement.sidebar.selectMeansOfTransportType"
            isOptional
            options={getMeansOfTransportTypeOptions()}
            value={localFilters[filterName] === undefined ? undefined : (localFilters[filterName] as string)}
            onChange={(item) => {
                setLocalFilters((prevState) => ({ ...prevState, [filterName]: item?.id }));
            }}
        />
    );
};
